import styles from './Top.module.scss';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { lockScreen } from '../../../store/actions/auth';
import Date from './Date/Date';
import LanguageSelector from '../../shared/LanguageSelector/LanguageSelector';
import CurrentLimit from './Balance/Balance';
import Account from './Account/Account';
import Modal from '../../shared/Modal/Modal';
import LockScreen from '../../shared/Modal/ModalContent/LockScreen/LockScreen';
import Devices from '../../shared/Modal/ModalContent/Devices/Devices';
import { getTranslation } from '../../../utils/translation';
import { changeAllDevicesModalProps } from '../../../store/actions/modals';
import Theme from './Theme/Theme';
import ReadMessage from '../../shared/Modal/ModalContent/Messages/ReadMessage/ReadMessage';
import {
    openFirstPriorityMessage,
    resetMessageModal,
    setPriorityMessages,
} from '../../../store/actions/messages';
import classNames from 'classnames';

export default function HeaderTop(props) {
    const dispatch = useDispatch();
    const { isLockedScreen } = useSelector(state => state.auth);
    const modals = useSelector(state => state.modals);
    const priorityMessages = useSelector(state => state.messages.priorityMessagesList);
    const { allDevicesModal, messageModal } = modals;

    const [isVisibleModal, setIsVisibleModal] = useState({
        lockScreenModal: false,
    });

    useEffect(() => {
        if (isLockedScreen) {
            setIsVisibleModal({ ...isVisibleModal, lockScreenModal: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLockedScreen]);

    const changeAllDevicesProps = () => {
        dispatch(changeAllDevicesModalProps({ isVisible: true }));
    };

    const handlePriorityMessage = messageId => {
        if (priorityMessages.find(message => message.id === messageId)) {
            const newPriorityMessages = priorityMessages.filter(
                message => message.id !== messageId
            );

            dispatch(setPriorityMessages(newPriorityMessages));
            dispatch(openFirstPriorityMessage(newPriorityMessages));
        }
    };

    const onMessageModalClose = id => {
        dispatch(resetMessageModal());
        handlePriorityMessage(id);
    };

    return (
        <>
            <Modal
                isVisible={allDevicesModal.isVisible}
                width='476px'
                textAlign='center'
                contentPadding='50px 0'
            >
                <Devices />
            </Modal>
            {isVisibleModal.lockScreenModal && (
                <Modal
                    isVisible={isVisibleModal.lockScreenModal}
                    width='476px'
                    textAlign='center'
                    contentPadding='50px 0'
                >
                    <LockScreen
                        closeModal={() =>
                            setIsVisibleModal({
                                ...isVisibleModal,
                                lockScreenModal: false,
                            })
                        }
                    />
                </Modal>
            )}
            {messageModal.isVisible && (
                <Modal
                    isVisible={messageModal.isVisible}
                    width='900px'
                    contentPadding='80px 20px 40px'
                >
                    <ReadMessage closeModal={onMessageModalClose} />
                </Modal>
            )}
            <div className={styles.headerTop}>
                <div className={styles.headerSection}>
                    <button
                        className={classNames(styles.headerButton, styles.headerButtonGreen)}
                        onClick={changeAllDevicesProps}
                    >
                        <i className={classNames('icon-device', styles.icon)} />
                        <span>{getTranslation('common.actions.allDevices')}</span>
                    </button>
                    <button
                        className={classNames(styles.headerButton)}
                        onClick={() => dispatch(lockScreen())}
                    >
                        <i className={classNames('icon-lock', styles.icon)} />
                        <span>{getTranslation('common.actions.lockScreen')}</span>
                    </button>
                    <Link to='/app/messages'>
                        <button className={classNames(styles.headerButton)}>
                            <i className={classNames('icon-mail', styles.icon)} />
                            <span>{getTranslation('common.actions.messages')}</span>
                            {props.cashier && props.cashier.messageCount > 0 && (
                                <span className={styles.msgCount}>
                                    {props.cashier.messageCount}
                                </span>
                            )}
                        </button>
                    </Link>
                </div>
                <div className={styles.headerSection}>
                    <CurrentLimit limit={props.cashier && props.cashier.currentLimit} />
                    {/*<HeaderSession isOpen={true} />*/}
                    <Account accountNumber={props.cashier && props.cashier.accountNumber} />
                </div>
                <div className={styles.headerSection}>
                    <Date />
                    <Theme />
                    <LanguageSelector />
                </div>
            </div>
        </>
    );
}
